<script>
import { mapGetters, mapActions } from 'vuex'

import { apiSecond } from '@/boot/axios'

import MainFilters from '@/components/MainFilters.vue'
import AqEmpty from '@/components/aqua/AqEmpty.vue'
import AqPageHeader from '@/components/aqua/AqPageHeader.vue'
import AqStatus from '@/components/aqua/AqStatus.vue'

export default {
	name: 'GrownIndex',
	components: {
		MainFilters,
		AqEmpty,
		AqPageHeader,
		AqStatus,
	},
	data() {
		return {
			applications: [],
			totalItems: 0,
			options: {
				itemsPerPage: 10,
				page: 1,
			},
			headers: [
				{ text: '№', value: 'id', width: '72px' },
				{ text: this.$t('labels.reportPeriod'), value: 'name' },
				{ text: this.$t('headers.created_at'), value: 'created_at', width: '200px' },
				{ text: this.$t('headers.report_status'), value: 'status', width: '200px' },
				{
					text: '',
					value: 'action',
					align: 'end',
					sortable: false,
					width: '140px',
				},
			],
			total: 0,
			errorMessage: {
				status: null,
				text: null,
			},
			message: {
				status: null,
				text: null,
			},
			loading: false,
		}
	},
	computed: {
		...mapGetters(['_getFishes', '_getUserObject']),
		isMagazinsCanEdit() {
			return (magazin) => {
				return magazin.status !== 'active'
			}
		},
		isUserReady() {
			return this.userObject && this.userObject.id
		},
		getHeaders() {
			return [
				...this.headers,
				...this._getFishes
					.filter((fish) => {
						return this.applications.some((item) => {
							return (
								item.fishs &&
								item.fishs.some((f) => {
									return f.fish_id === fish.id
								})
							)
						})
					})
					.map((fish) => {
						return {
							text: fish.name,
							value: 'fish',
							fish_id: fish.id,
							width: '150px',
							sortable: false,
						}
					}),
			]
		},
		userObject() {
			return this.$store.state.userObject
		},
		canCreate() {
			return this.$store.getters.userPermission(['change_trade'])
		},
		basePath() {
			return '/' + this.$i18n.locale + '/account/logs/grown'
		},
	},
	methods: {
		...mapActions(['_fetchFishes']),
		search() {
			this.apiGetList()
			this.getTotalID()
		},
		findFish(fishs, id) {
			if (!fishs || !Array.isArray(fishs)) return 0
			return this.$options.filters.formatNumber(
				fishs.find((fish) => fish.fish_id == id)?.value || 0,
			)
		},
		pagination(options) {
			this.apiGetList(options.page, options.itemsPerPage, options)
		},
		openRecord(item) {
			this.$router.push(this.basePath + '/' + item.id)
		},
		getQueries() {
			let queries = ''
			if (this.$route.query.status) queries += '&status=' + this.$route.query.status
			if (this.$route.query.start_at) queries += '&start_at=' + this.$route.query.start_at
			if (this.$route.query.finish_at) queries += '&end_at=' + this.$route.query.finish_at
			if (this.$route.query.reservoirs) {
				this.$route.query.reservoirs.forEach((reservoir) => {
					queries += '&reservoirs[]=' + reservoir
				})
			}

			return queries
		},
		apiGetList(page = 1, itemsPerPage = 10, options) {
			if (!this.isUserReady) {
				return
			}

			this.loading = true

			const queriesString = this.getQueries()
			let queries =
				`user_id=${this.userObject.id}&page=${page}&per_page=${itemsPerPage}` +
				(queriesString ? '&' + queriesString : '')

			if (options?.sortBy?.length) {
				queries += `&sort[${options.sortBy[0]}]=${
					!options.sortDesc?.length || !options.sortDesc[0] ? 'asc' : 'desc'
				}`
			}

			apiSecond
				.get(`v1/grown/list?${queries}`)
				.then((response) => {
					if (response.data) {
						this.applications = response.data.data
						this.totalItems = response.data.total
						this.options.page = response.data.current_page || 1
						this.options.itemsPerPage = parseInt(response.data.per_page) || 10
					}
				})
				.catch((error) => {
					if (error?.response?.status == 500) {
						this.errorMessage.status = 500
						this.errorMessage.text = this.$t('system_message.500')
					}
					if (error?.response?.status == 401) {
						this.errorMessage.status = 401
						this.errorMessage.text = error.response.data.error_message
						this.$router.push('/' + this.$i18n.locale + '/login')
					}
					if (error?.response?.status == 422) {
						this.errorMessage.status = 422
						this.errorMessage.text = error.response.data.error_message
					}
					if (error?.response?.status == 403) {
						this.errorMessage.status = 403
						this.errorMessage.text = error?.response?.data?.message
					}
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	beforeCreate() {
		if (!localStorage.token) {
			this.$router.push('/ru/login')
		}
	},
	async mounted() {
		await this._fetchFishes()

		if (this.isUserReady) {
			this.apiGetList()
		} else {
			this.$nextTick(() => {
				if (this.isUserReady) {
					this.apiGetList()
				}
			})
		}
	},
	head: {
		title() {
			return {
				inner: this.$t(`titles.grownJournals`),
			}
		},
		meta: [],
	},
}
</script>

<template>
	<div
		class="wrap__content aq-page"
		v-bind:class="{ 'wrap__content--preloader': !applications || !$store.state.userObject }"
	>
		<v-preloader v-if="!$store.state.userObject" :message="errorMessage"></v-preloader>

		<div class="container" v-if="$store.state.userObject">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['GrownManagement', 'TradeManagementMain']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content aq-shell">
							<AqPageHeader
								:title="$t('titles.grownJournals')"
								:eyebrow="$t('aqua.ui.grown.eyebrow')"
								:subtitle="$t('aqua.ui.grown.list_hint')"
							>
								<template v-if="canCreate" #actions>
									<router-link :to="basePath + '/create'" class="aq-btn aq-btn--primary">
										<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
											<path d="M12 5v14M5 12h14" />
										</svg>
										{{ $t('labels.record_to_journal') }}
									</router-link>
								</template>
							</AqPageHeader>

							<section class="aq-card aq-filters">
								<MainFilters
									:filter-keys="['reservoirs', 'status', 'start_at', 'finish_at']"
									:filter-options="{
										reservoirs: {
											multiple: true,
											confinesValue: _getUserObject?.quota_ponds,
										},
										brigades: {
											multiple: false,
										},
									}"
									@search="search"
								/>
							</section>

							<section class="aq-card aq-table">
								<v-data-table
									:headers="getHeaders"
									:items="applications"
									:loading="loading"
									:options.sync="options"
									:server-items-length="totalItems"
									:footer-props="{
										'items-per-page-options': [5, 10, 20, 30, 40, 50],
									}"
									@update:options="pagination"
									@click:row="openRecord"
								>
									<template slot="item.id" slot-scope="{ item }">
										<span class="aq-table__id">{{ item.id }}</span>
									</template>
									<template v-slot:item.name="{ item }">
										<router-link :to="basePath + '/' + item.id" class="aq-table__link" @click.native.stop>
											{{ $t('aqua.ui.grown.record_from', { date: $options.filters.formatOnlyDate(item.catch_at) }) }}
										</router-link>
										<span v-if="item.status === 'rejected' && item.reject_reason" class="aq-table__note">
											{{ item.reject_reason }}
										</span>
									</template>
									<template v-slot:item.created_at="{ item }">
										<span class="aq-table__muted">{{ item.created_at | formatDate }}</span>
									</template>
									<template v-slot:item.status="{ item }">
										<AqStatus
											v-if="item.status"
											:value="item.status"
											:label="$t('statusses.readGrownAll.' + item.status)"
										/>
										<span v-else class="aq-table__muted">—</span>
									</template>
									<template v-slot:item.action="{ item }">
										<router-link :to="basePath + '/' + item.id" class="aq-btn aq-btn--ghost aq-btn--sm" @click.native.stop>
											{{ $t('aqua.ui.grown.open') }}
											<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
												<path d="M9 5l7 7-7 7" />
											</svg>
										</router-link>
									</template>
									<template #no-data>
										<AqEmpty :title="$t('aqua.ui.grown.empty_title')" :text="$t('aqua.ui.grown.empty_text')">
											<router-link v-if="canCreate" :to="basePath + '/create'" class="aq-btn aq-btn--primary">
												{{ $t('labels.record_to_journal') }}
											</router-link>
										</AqEmpty>
									</template>
									<v-alert slot="no-results" :value="true" color="error">
										{{ $t('system_message.search') }}
									</v-alert>
								</v-data-table>
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
header .header__row {
	display: flex;
}
</style>

<style scoped>
.aq-shell {
	background: var(--aq-bg);
}
.aq-filters {
	padding: 20px 24px;
}
.aq-filters ::v-deep > .row {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
	align-items: end;
	gap: 14px 16px;
	margin: 0;
}
.aq-filters ::v-deep > .row > [class*='col'] {
	width: auto;
	max-width: none;
	flex: none;
	padding: 0;
}
.aq-filters ::v-deep .multiselect__tags,
.aq-filters ::v-deep input[type='date'] {
	min-height: 44px;
	border: 1px solid var(--aq-border-strong) !important;
	border-radius: 10px !important;
}
.aq-filters ::v-deep .multiselect__tags:hover,
.aq-filters ::v-deep input[type='date']:hover {
	border-color: var(--aq-primary) !important;
}
.aq-filters ::v-deep .input-btn.form__line--btn,
.aq-filters ::v-deep .btn--link--plus {
	min-height: 44px;
	margin: 0;
	padding: 10px 20px;
	border: 1px solid var(--aq-primary);
	border-radius: 10px;
	background: var(--aq-primary);
	color: #fff;
	font-size: 15px;
	font-weight: 500;
	transition: background 0.2s var(--aq-ease), color 0.2s var(--aq-ease);
}
.aq-filters ::v-deep .input-btn.form__line--btn:hover {
	background: var(--aq-primary-hover);
}
.aq-filters ::v-deep .btn--link--plus {
	border-color: transparent;
	background: transparent;
	color: var(--aq-primary) !important;
}
.aq-filters ::v-deep .btn--link--plus:hover {
	background: var(--aq-primary-soft);
}
.aq-table {
	overflow: hidden;
}
.aq-table ::v-deep .v-data-table {
	background: transparent;
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
	height: 46px;
	padding: 0 16px;
	border-bottom: 1px solid var(--aq-border) !important;
	background: #f7faff;
	color: var(--aq-muted) !important;
	font-size: 12px !important;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	white-space: nowrap;
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
	height: 64px;
	padding: 10px 16px;
	border-bottom: 1px solid var(--aq-border) !important;
	color: var(--aq-ink);
	font-size: 15px;
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__empty-wrapper) {
	cursor: pointer;
	transition: background 0.15s var(--aq-ease);
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__empty-wrapper):hover {
	background: #f7faff !important;
}
.aq-table ::v-deep .v-data-table__empty-wrapper:hover {
	background: transparent !important;
}
.aq-table ::v-deep .v-data-footer {
	padding: 6px 12px;
	border-top: 0;
	color: var(--aq-muted);
}
.aq-table__id {
	color: var(--aq-muted);
	font-weight: 600;
}
.aq-table__link {
	display: block;
	color: var(--aq-ink);
	font-weight: 600;
	text-decoration: none;
}
.aq-table__link:hover,
.aq-table__link:focus-visible {
	color: var(--aq-primary);
	outline: none;
}
.aq-table__note {
	display: block;
	max-width: 420px;
	margin-top: 2px;
	overflow: hidden;
	color: var(--aq-danger);
	font-size: 13px;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.aq-table__muted {
	color: var(--aq-muted);
	font-size: 14px;
}
.aq-btn--sm {
	min-height: 36px;
	padding: 6px 12px;
	font-size: 14px;
}
@media (max-width: 1280px) {
	.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
	.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
		width: auto !important;
		min-width: 0 !important;
		padding-right: 10px;
		padding-left: 10px;
	}
	.aq-table__note {
		max-width: 240px;
	}
	.aq-table ::v-deep table > thead > tr > th:nth-child(1),
	.aq-table ::v-deep table > tbody > tr > td:nth-child(1),
	.aq-table ::v-deep table > thead > tr > th:nth-child(3),
	.aq-table ::v-deep table > tbody > tr > td:nth-child(3) {
		display: none;
	}
}
@media (max-width: 768px) {
	.aq-filters {
		padding: 16px;
	}
}
</style>
